var exports = {
  "i": "xaee3c4fa--6ac347--wrapper",
  "n": "xaee3c4fa--6ac347--link",
};

module.exports = exports;
